import { CpSetupAuthorizationsInterface } from '../../../interfaces/dto/setup-authorizations/cp-setup-authorizations-interface';
import { CpServicesModel } from '../services/cp-services-model';
import { CpRequestFieldsModel } from '../request-fields/cp-request-fields-model';

export class CpSetupAuthorizationsModel implements CpSetupAuthorizationsInterface {
  services: CpServicesModel[] = [];
  RequestFields: CpRequestFieldsModel[] = [];

  constructor(init?: Partial<CpSetupAuthorizationsModel>) {
    Object.assign(this, init);
  }
}
